export default {
  ownerid: 'ownerId',
  votinground: 'votingRound',
  votingrounds: 'votingRounds',
  ethaddress: 'ethereumAddress',
  ethaddressverified: 'ethereumAddressVerified',
  ethaddressVerified: 'ethereumAddressVerified',
  statusValidateddAt: 'statusValidatedByUserAt',
};
